import { render, staticRenderFns } from "./selectorDeFecha.vue?vue&type=template&id=771bbf2c"
import script from "./selectorDeFecha.vue?vue&type=script&lang=js"
export * from "./selectorDeFecha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports